import { defineFcm } from '../shared/factory';

// Temporary: remove once submit-time rejection is rolled out and `comment_blocked_url_hosts` alone should drive it.
export const FCM_COMMENT_BLOCKED_URL_SUBMIT_ENABLED = defineFcm('comment_blocked_url_submit_enabled')
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'squad-site-platform',
		scope: 'corgi-middle-end',
		supportedGroups: { global: true },
		context: 'Supporter comments and reasons for signing',
		description: `Temporary rollout gate for rejecting new comments and signatures whose text contains a URL on a host listed in "comment_blocked_url_hosts".

			- When false, nothing is rejected on submit, whatever "comment_blocked_url_hosts" contains. Display-time redaction is unaffected and is driven by "comment_blocked_url_hosts" alone.
			- When true, a submission containing a blocked URL is rejected with a "blockedUrls" error, but only if "comment_blocked_url_hosts" lists at least one host.

			Only turn this on once the front-end can show the error. Delete this config when the rollout is complete.`,
	});
